<script lang="ts">
  
  import { currentLanguage } from "../../Services/i18n"

  const languages = ['es', 'en', 'fr', 'de', 'it', 'pt']

  function setLang(lang: string): void {
    $currentLanguage = lang
  }

</script>

<div class="lang-icons-select">
  {#each languages as language}  
    <button
      type="button"
      class="lang-icon"
      class:active={$currentLanguage === language}
      on:click={() => setLang(language)}
      >
      <img src="/images/flags/{language}.svg" alt="">
    </button>
  {/each}
</div>

<style lang="scss">

  .lang-icons-select {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1.5rem;
  }

  .lang-icon {
    background: transparent;
    padding: 0;
    filter: grayscale(0.5);
    transition-property: filter, transform;
    transition-duration: 300ms;
    border-radius: 100%;

    &.active {
      transform: scale(1.2);
      filter: grayscale(0);
      border: 3px solid var(--color-secondary);
    }

    img {
      display: block;
      width: 50px;
      height: 50px;
      object-fit: cover;
    }
  }

</style>
